import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
import Pedidos from '../views/Pedidos'
import Historico from '../views/Historico'
import Configs from '../views/Configs'
import SobreApp from '../views/SobreApp'
import PoliticaPrivacidade from '../views/PoliticaPrivacidade'
import Recuperar from '../views/RecuperarSenha.vue'
import Logs from '../views/Logs.vue'
import Offline from '../views/Offline'
import P404 from '../views/P404'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/recuperar',
    name: 'Recuperar',
    component: Recuperar
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: Pedidos
  },
  {
    path: '/historico',
    name: 'Historico',
    component: Historico
  },
  {
    path: '/configs',
    name: 'Configs',
    component: Configs
  },
  {
    path: '/sobre-app',
    name: 'SobreApp',
    component: SobreApp
  },
  {
    path: '/politica-de-privacidade',
    name: 'PoliticaPrivacidade',
    component: PoliticaPrivacidade
  },
  {
    path: '/logs',
    name: 'Logs',
    component: Logs
  },
  {
    path: '/offline',
    name: 'Offline',
    component: Offline
  },
  {
    path: '*',
    name: '404',
    component: P404
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

export default router
